// Import main dependencies
import { createStore, combineReducers } from "redux";

// Import reducers

import dictionaryReducer from "./reducers/dictionary";

// Create store
const store = createStore(
  combineReducers({
    dictionary: dictionaryReducer
  })
);

export default store;



// WEBPACK FOOTER //
// ./src/apps/vocabularium/data/redux/store.js